module.exports = __webpack_public_path__ + "img/ad.f58f6d94.png";